var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33564 0.708984H4.34227V5.80652H0.537109V17.4353C0.537109 19.9238 1.35862 21.7901 3.00163 23.0344C4.42695 24.0981 6.44387 24.7071 9.0524 24.8615V21.9169C6.90132 21.2487 4.34263 19.2846 4.34263 17.4353V5.91323H6.33564V0.708984ZM11.7706 24.8637V21.9305C13.944 21.2759 16.5746 19.2974 16.5746 17.4353V5.91323H14.8539V0.708984H16.8473V5.80652H20.3258V17.4353C20.3258 19.9238 19.4922 21.7901 17.825 23.0344C16.4133 24.1034 14.3952 24.7132 11.7706 24.8637ZM9.60061 0.708984H11.594V5.91323H9.60061V0.708984Z",
    fill: "url(#paint0_linear_3044_13748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3044_13748",
    x1: 10.4315,
    y1: 0.708984,
    x2: 10.4315,
    y2: 24.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#0C7B93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C7B93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugLogoIcon);
export default __webpack_public_path__ + "static/media/plug-logo-icon.6194bb91494b232aff9009738f986eb6.svg";
export { ForwardRef as ReactComponent };